<script>
  import Lightbox from '$lib/lightbox/Index.svelte';
  export let preview;
  let image = preview.img;

  let lightbox = {
    type: 'image',
    scrollable: false,
    image: {
      ...image,
      title: preview.title,
    },
  };

  let openLightbox;
  function handleOpenClick() {
    openLightbox();
  }
</script>

<div class="preview">
  <div class="preview__img" on:click={handleOpenClick}>
    {#if preview.img}
      <img
        width="270"
        height="220"
        src={preview.img.src}
        alt={preview.img.alt}
        loading="lazy"
      />
    {/if}
  </div>
  {#if preview.title}
    <p class="preview__title text-small">{preview.title}</p>
  {/if}
</div>

<Lightbox {lightbox} bind:open={openLightbox} />

<style lang="scss">
  .preview {
    padding: 2rem;
    border: 1px solid $light-border;
    border-radius: 0.5rem;
    transition: all 0.3s;

    &:hover {
      border-color: var(--aqua-gradient);
    }

    &__img {
      aspect-ratio: 27/22;
      cursor: pointer;
    }

    &__title {
      color: var(--royal-light);
      margin: 2rem 0 0;
    }
  }
</style>
